module.exports = __webpack_public_path__ + "img/lk.9e0e66b4.svg";